import { useMemo, useState } from 'react'
import { H1, P1, MainButton } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import ImgLazy from 'components/ui/ImgLazy/ImgLazy'
import { getCdnImg } from 'utils/getters'
import styles from './QuizYesNo.module.scss'

const toAnswer = (correctAnswer, currentAnswer) => (correctAnswer === currentAnswer ? 1 : 2)

const QuizYesNo = ({
  webpart: {
    title,
    description,
    correctAnswerText,
    wrongAnswerText,
    correctAnswer,
    questionBackgroundColor,
    correctAnswerBackgroundColor,
    wrongAnswerBackgroundColor,
    correctAnswerTextColor,
    wrongAnswerTextColor,
    questionTextColor,
    questionImage,
    correctAnswerImage,
    wrongAnswerImage,
    questionTrueText,
    questionFalseText
  }
}) => {
  const [answer, setAnswer] = useState(0)

  const correctAnswerBool = useMemo(() => (correctAnswer === 'true' ? 1 : 2), [correctAnswer])

  return (
    <>
      {answer === 0 && (
        <section className={styles.QuizYesNo} style={{ backgroundColor: questionBackgroundColor }}>
          <div className={styles.Block}>
            <div className={styles.LeftSide}>
              <H1 weight="bold" type="heading" style={{ color: questionTextColor }} className={styles.Title}>
                {title}
              </H1>
              <P1
                weight="light"
                nestedStyles
                style={{ color: questionTextColor }}
                className={styles.Description}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </div>

            <div className={styles.RightSide}>
              <div className={`${styles.ImgBlock}`}>
                <ImgLazy alt={title} src={getCdnImg(questionImage, 500)} />
              </div>

              <div className={styles.Buttons}>
                <div className={styles.Container}>
                  <MainButton
                    size="lg"
                    className={`${styles.Button} ${styles.First}`}
                    onClick={() => setAnswer(toAnswer(correctAnswerBool, 1))}
                  >
                    {questionTrueText || `True`}
                  </MainButton>
                </div>
                <div className={styles.Container}>
                  <MainButton
                    size="lg"
                    className={`${styles.Button} ${styles.Last}`}
                    onClick={() => setAnswer(toAnswer(correctAnswerBool, 2))}
                  >
                    {questionFalseText || `False`}
                  </MainButton>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {answer !== 0 && (
        <section
          className={styles.QuizYesNo}
          style={{ backgroundColor: answer === 1 ? correctAnswerBackgroundColor : wrongAnswerBackgroundColor }}
        >
          <div className={styles.Block}>
            <div className={styles.LeftSide}>
              <H1
                weight="bold"
                type="heading"
                style={{ color: answer === 1 ? correctAnswerTextColor : wrongAnswerTextColor }}
                className={styles.Title}
              >
                {title}
              </H1>
              <P1
                weight="light"
                style={{ color: answer === 1 ? correctAnswerTextColor : wrongAnswerTextColor }}
                className={styles.Description}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </div>

            <div className={styles.RightSide}>
              <div className={`${styles.ImgBlock}`}>
                <ImgLazy alt={title} src={getCdnImg(answer === 1 ? correctAnswerImage : wrongAnswerImage, 500)} />
              </div>

              <div className={styles.Content}>
                <P1
                  weight="semibold"
                  style={{ color: answer === 1 ? correctAnswerBackgroundColor : wrongAnswerBackgroundColor }}
                >
                  {answer === 1 ? correctAnswerText : wrongAnswerText}
                </P1>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

QuizYesNo.propTypes = {
  webpart: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    correctAnswerText: PropTypes.string,
    wrongAnswerText: PropTypes.string,
    correctAnswer: PropTypes.string,
    questionBackgroundColor: PropTypes.string,
    correctAnswerBackgroundColor: PropTypes.string,
    wrongAnswerBackgroundColor: PropTypes.string,
    correctAnswerTextColor: PropTypes.string,
    wrongAnswerTextColor: PropTypes.string,
    questionTextColor: PropTypes.string,
    questionImage: PropTypes.string,
    correctAnswerImage: PropTypes.string,
    wrongAnswerImage: PropTypes.string,
    questionTrueText: PropTypes.string,
    questionFalseText: PropTypes.string
  })
}

QuizYesNo.defaultProps = {
  webpart: {
    title: '',
    description: '',
    correctAnswerText: '',
    wrongAnswerText: '',
    correctAnswer: '',
    questionBackgroundColor: '',
    correctAnswerBackgroundColor: '',
    wrongAnswerBackgroundColor: '',
    correctAnswerTextColor: '',
    wrongAnswerTextColor: '',
    questionTextColor: '',
    questionImage: '',
    correctAnswerImage: '',
    wrongAnswerImage: '',
    questionTrueText: '',
    questionFalseText: ''
  }
}

export default QuizYesNo
